const ASSIGNED_STATUS_BY_JOB_STATUS: Record<string, string> = {
  JOB_STATUS_READY_FOR_TRANSCRIBING: 'JOB_STATUS_TRANSCRIBING',
  JOB_STATUS_TRANSCRIBING: 'JOB_STATUS_TRANSCRIBING',
  JOB_STATUS_READY_FOR_PROOFREADING: 'JOB_STATUS_PROOFING',
  JOB_STATUS_PROOFING: 'JOB_STATUS_PROOFING',
};

const UNASSIGNED_STATUS_BY_JOB_STATUS: Record<string, string> = {
  JOB_STATUS_READY_FOR_TRANSCRIBING: 'JOB_STATUS_READY_FOR_TRANSCRIBING',
  JOB_STATUS_TRANSCRIBING: 'JOB_STATUS_READY_FOR_TRANSCRIBING',
  JOB_STATUS_READY_FOR_PROOFREADING: 'JOB_STATUS_READY_FOR_PROOFREADING',
  JOB_STATUS_PROOFING: 'JOB_STATUS_READY_FOR_PROOFREADING',
  JOB_STATUS_READY_FOR_FINAL: 'JOB_STATUS_READY_FOR_FINAL',
  JOB_STATUS_FINALIZING: 'JOB_STATUS_READY_FOR_FINAL',
  JOB_STATUS_COMPLETE: 'JOB_STATUS_COMPLETE',
};

export const LEAVE_STATUS_AS_IT_IS = 'Leave as it is';

export const getDefaultAssignStatus = (jobStatus: string, hasAssignee: boolean) => {
  if (hasAssignee) {
    return ASSIGNED_STATUS_BY_JOB_STATUS[jobStatus] ?? LEAVE_STATUS_AS_IT_IS;
  }
  return UNASSIGNED_STATUS_BY_JOB_STATUS[jobStatus] ?? 'JOB_STATUS_READY_FOR_TRANSCRIBING';
};
